var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.338,
    height: 12.869,
    viewBox: "0 0 16.338 12.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #002c5f;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18576",
    "data-name": "Group 18576",
    transform: "translate(1.004 11.455) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7511",
    "data-name": "Path 7511",
    className: "cls-1",
    d: "M-17240.6-5493.96v13.658",
    transform: "translate(17245.594 5493.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7512",
    "data-name": "Path 7512",
    className: "cls-2",
    d: "M0,0V7.1H7.1",
    transform: "translate(0 8.898) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/Icon_Right.e21e772f699282dfc0fe0e50970038e8.svg";
export { ForwardRef as ReactComponent };